export default __webpack_public_path__ + "static/industry-healthcare-3d3d1fa26f209e45f6c1f85d24ce76dd.webp";